import { render, staticRenderFns } from "./Spedizioni.vue?vue&type=template&id=6c69cb88&scoped=true"
import script from "./Spedizioni.vue?vue&type=script&lang=ts"
export * from "./Spedizioni.vue?vue&type=script&lang=ts"
import style0 from "./Spedizioni.vue?vue&type=style&index=0&id=6c69cb88&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c69cb88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c69cb88')) {
      api.createRecord('6c69cb88', component.options)
    } else {
      api.reload('6c69cb88', component.options)
    }
    module.hot.accept("./Spedizioni.vue?vue&type=template&id=6c69cb88&scoped=true", function () {
      api.rerender('6c69cb88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Spedizioni.vue"
export default component.exports